import React, { useState, useEffect } from "react";
import ProjectPropOne from "./itemProp/ProjectPropOne";
import SectionTitle from "../../elements/section-title/SectionTitle";
import { ProjectSecondData } from "./ProjectSecondData";

const AllData = [...ProjectSecondData];

const ProjectOne = ({
  portfolio1103,
  parentClass,
  colSize,
  itemShow,
  columnGap,
}) => {
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    // Display all items from ProjectData without filtering
    setVisibleItems(AllData);
  }, []);

  // const handleChange = (e) => {
  //   e.preventDefault();
  //   let target = e.target.textContent;

  //   setActiveFilter(target);

  //   let tempData = [];
  //   if (target === filters[0].label) {
  //     tempData = getAllItems.filter((data) => data.id <= visiableProject);
  //   } else {
  //     for (let i = 0; i < getAllItems.length; i++) {
  //       const element = getAllItems[i];
  //       let categories = element["category"];

  //       if (categories.includes(target)) {
  //         tempData.push(element);
  //       }
  //     }
  //   }
  //   setVisibleItems(tempData);
  // };

  return (
    <>
      <div
        className={`section section-padding-2 ${
          parentClass ? parentClass : ""
        }`}
      >
        <div className="container">
          <SectionTitle
            subtitle="Our Project"
            title="Few of our <br>
                        finest works."
            description="We believe in delivering quality-oriented breakthrough products and services aiming towards transforming the digital world."
            textAlignment="heading-left mb--40"
            textColor=""
          />
          <div className="isotope-button isotope-project-btn">
            {/* {filters.map((filter) => (
              <button
                onClick={handleChange}
                className={filter.label === activeFilter ? "is-checked" : " "}
                key={filter.id}
              >
                {filter.label}
              </button>
            ))} */}
          </div>
          <div className={`row ${columnGap ? columnGap : "row-35"}`}>
            {visibleItems.map((data) => (
              <div className={colSize ? colSize : "col-md-6"} key={data.id}>
                <ProjectPropOne
                  projectStyle=""
                  portfolio1103={portfolio1103}
                  portfolio={data}
                />
              </div>
            ))}
          </div>
        </div>
        <ul className="shape-group-7 list-unstyled">
          <li className="shape shape-1">
            <img
              src={process.env.PUBLIC_URL + "/images/others/circle-2.png"}
              alt="circle"
              loading="lazy"
              width="886"
              height="888"
            />
          </li>
          <li className="shape shape-2">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
              alt="Line"
              loading="lazy"
              width="150"
              height="150"
            />
          </li>
          <li className="shape shape-3">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
              alt="Line"
              loading="lazy"
              width="88"
              height="88"
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default ProjectOne;
